import { useAtomValue } from "jotai";
import { Center, Text3D } from "@react-three/drei";
import { useParams } from "wouter";
import { languageAtom, hostAtom, clientAtom } from "../../GlobalState.jsx";
import translations from "../../dictionaries/translations.js";
import MeshColors from "../MeshColors.jsx";

export default function TopSection({ position }) {
  const params = useParams();
  const roomId = params.id;
  const language = useAtomValue(languageAtom)
  const host = useAtomValue(hostAtom)
  const client = useAtomValue(clientAtom)
  const isHost = client.socketId === host.socketId

  return <group name='top-section' position={position}>
    <Center position={[0, 0, 0]} rotation={[-Math.PI/2, 0, 0]} key={Math.random()}>
      <Text3D
        font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
        size={0.8}
        height={0.01}
      >
        {translations.lobby.yutNoriTitle[language]}
        <meshStandardMaterial color='orange'/>
      </Text3D>
    </Center>
    <Center position={[0, 0, 1.4]} rotation={[-Math.PI/2, 0, 0]} key={Math.random()}>
      <Text3D
        font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
        size={0.5}
        height={0.01}
      >
        {`${translations.lobby.roomId[language]}: ${roomId}${isHost ? ` (${translations.lobby.host[language]})` : ''}`}
        <meshStandardMaterial color='orange'/>
      </Text3D>
    </Center>
  </group>
}
